/* ======================================================================
   ANDHEKA — AJAX cart: add / change / remove, drawer, inventory guard.
   Over-stock is detected from Shopify capping the quantity on change.js
   (works when a variant's inventory policy is "deny").
   ====================================================================== */
(function () {
  'use strict';
  var A = window.Andheka || {};
  var R = A.routes || {};
  var drawer = document.querySelector('[data-cart]');
  var panel = drawer && drawer.querySelector('.ac-cart-panel');
  var body = drawer && drawer.querySelector('[data-cart-body]');
  var foot = drawer && drawer.querySelector('[data-cart-foot]');

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = A.moneyFormat || '${{amount}}';
    function fnum(n, dec, ts, ds) {
      dec = dec == null ? 2 : dec; ts = ts == null ? ',' : ts; ds = ds || '.';
      var s = (Math.abs(n) / 100).toFixed(dec);
      var p = s.split('.');
      var intp = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return intp + (p[1] ? ds + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return fnum(cents, 2);
        case 'amount_no_decimals': return fnum(cents, 0);
        case 'amount_with_comma_separator': return fnum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fnum(cents, 0, '.', ',');
        default: return fnum(cents, 2);
      }
    });
  }

  function setCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- render lines from cart JSON ---------- */
  function render(cart) {
    setCounts(cart.item_count);
    if (foot) foot.hidden = cart.item_count === 0;
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="ac-cart-empty"><div class="ac-cart-empty-t">Nothing held yet.</div><a class="ac-cart-empty-btn" href="/collections/all">Enter the shop</a></div>';
      return;
    }
    var html = '<ul class="ac-cart-lines">';
    cart.items.forEach(function (item, i) {
      var size = (item.variant_title && item.variant_title.indexOf('Default') === -1)
        ? '<div class="ac-cart-size">Size ' + item.variant_title + '</div>' : '';
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') + '" alt="" loading="lazy">' : '';
      html +=
        '<li class="ac-cart-line" data-line="' + (i + 1) + '" data-key="' + item.key + '">' +
          '<a class="ac-cart-thumb" href="' + item.url + '">' + img + '</a>' +
          '<div class="ac-cart-info">' +
            '<div class="ac-cart-row"><span>' + item.product_title + '</span><span>' + money(item.final_line_price) + '</span></div>' +
            size +
            '<div class="ac-cart-qty"><button type="button" data-qty-down aria-label="Decrease quantity">&minus;</button><span data-qty-input data-qty="' + item.quantity + '">' + item.quantity + '</span><button type="button" data-qty-up aria-label="Increase quantity">+</button></div>' +
            '<button type="button" class="ac-cart-remove" data-qty-remove aria-label="Remove">Remove</button>' +
            '<p class="ac-cart-limit" data-limit-msg hidden></p>' +
          '</div>' +
        '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    var sub = drawer.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
  }

  function getCart() { return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  /* ---------- open / close ---------- */
  function open() {
    if (!drawer) return;
    drawer.hidden = false;
    void drawer.offsetWidth; // force reflow so the slide-in transition actually runs (no sudden pop)
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; if (panel) panel.classList.remove('is-expanded'); }, 600);
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function () { open(); getCart().then(render); });
  });
  if (drawer) {
    drawer.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    // mobile: grip expands the risen card
    var grip = drawer.querySelector('[data-cart-grip]');
    if (grip && panel) grip.addEventListener('click', function () { panel.classList.toggle('is-expanded'); });
    body && body.addEventListener('scroll', function () { if (body.scrollTop > 4 && panel) panel.classList.add('is-expanded'); });
  }

  /* ---------- add to cart ---------- */
  function overStockMsg(max) { return (A.inventoryMsg || 'We hold only {{ max }} of this, for now.').replace(/\{\{\s*max\s*\}\}/g, max); }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"], [data-add-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var errEl = form.querySelector('[data-add-error]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

    // over-stock guard: account for what's ALREADY in the cart for this variant
    var max = parseInt(form.dataset.max, 10);
    var vid = parseInt((form.querySelector('[data-variant-input], [name=id]') || {}).value, 10);
    var wanted = parseInt((form.querySelector('[name=quantity]') || {}).value || 1, 10);

    function fail(msg) {
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      if (btn) { if (btn._origHtml != null) btn.innerHTML = btn._origHtml; btn.classList.remove('is-adding'); btn.disabled = false; }
    }

    function proceed() {
      if (btn) { btn._origHtml = btn.innerHTML; btn.classList.add('is-adding'); btn.disabled = true; }
      open(); // optimistic: the drawer glides in instantly, then fills when the cart returns
      fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            close();
            var m = (!isNaN(max)) ? overStockMsg(max) : (res.d.description || res.d.message || 'Unavailable.');
            fail(m);
            return;
          }
          return getCart().then(render);
        })
        .catch(function () { fail('Something went wrong.'); })
        .finally(function () { if (btn) { if (btn._origHtml != null) btn.innerHTML = btn._origHtml; btn.classList.remove('is-adding'); btn.disabled = false; } });
    }

    // if we know the cap, check the cart first so "already have the max" is caught with a calm message (no drawer flash)
    if (!isNaN(max) && vid) {
      getCart().then(function (cart) {
        var have = 0;
        (cart.items || []).forEach(function (it) { if (it.variant_id === vid) have += it.quantity; });
        if (have + wanted > max) { fail(overStockMsg(max)); return; }
        proceed();
      }).catch(proceed);
      return;
    }
    proceed();
  });

  /* ---------- quantity change / remove (with over-stock detection) ---------- */
  function showLimit(line, text) {
    var fresh = drawer.querySelector('.ac-cart-line[data-line="' + line + '"]');
    var msg = fresh && fresh.querySelector('[data-limit-msg]');
    if (msg) { msg.textContent = text; msg.hidden = false; setTimeout(function () { if (msg) msg.hidden = true; }, 4200); }
  }
  function changeLine(line, qty, lineEl) {
    return fetch(R.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        // Shopify refuses an over-stock increase with a 422 + error object (NOT a cart).
        // Re-fetch the real cart, re-render, and surface the calm message on the fresh line.
        if (!res.ok) {
          return getCart().then(function (cart) {
            render(cart);
            var have = cart.items[line - 1] && cart.items[line - 1].quantity;
            var desc = (res.d && (res.d.description || res.d.message)) || '';
            var num = desc.match(/(\d+)/);
            showLimit(line, (num ? overStockMsg(num[1]) : (!isNaN(have) ? overStockMsg(have) : desc || 'That is all we have, for now.')));
          });
        }
        var cart = res.d;
        // it can also silently CAP (return a cart with fewer than requested)
        var actual = cart.items[line - 1] && cart.items[line - 1].quantity;
        var capped = (qty > 0 && actual != null && actual < qty);
        render(cart);
        if (capped) showLimit(line, overStockMsg(actual));
      });
  }

  document.addEventListener('click', function (e) {
    var lineEl = e.target.closest('.ac-cart-line');
    if (!lineEl) return;
    var line = parseInt(lineEl.dataset.line, 10);
    var input = lineEl.querySelector('[data-qty-input]');
    var q = input ? parseInt(input.getAttribute('data-qty') || input.textContent, 10) : 1;
    if (e.target.closest('[data-qty-up]')) changeLine(line, q + 1, lineEl);
    else if (e.target.closest('[data-qty-down]')) changeLine(line, Math.max(0, q - 1), lineEl);
    else if (e.target.closest('[data-qty-remove]')) changeLine(line, 0, lineEl);
  });

  // expose for product page / other scripts
  window.AndhekaCart = { open: open, close: close, refresh: function () { return getCart().then(render); }, render: render, money: money };
})();
